<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="si_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.si_name || "名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.si_name"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="si_spec">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.si_spec || "规格"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.si_spec"
              placeholder="请输入"
            />
          </div>
        </div>
        <combo-field
          slot="si_unit"
          :label="customLabel.si_unit || '单位'"
          v-model="form.main.si_unit"
          url="/api/document/productunit/getCombo"
        />
        <currency-field
          slot="si_currency"
          :label="customLabel.si_currency || '币别'"
          v-model="form.main.si_currency"
        />
        <div class="weui-cell" slot="si_price">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.si_price || "含税单价"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.si_price"
              placeholder="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="si_renewprice">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.si_renewprice || "续费单价"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.si_renewprice"
              placeholder="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="si_remark">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.si_remark || '备注'"
              rows="3"
              v-model="form.main.si_remark"
              maxlength="100"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.si_remark ? form.main.si_remark.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
        <custom-field 
          :label="customLabel.si_text1 || '自定义字段1'"
          v-model="form.main.si_text1" :caller="caller" fieldName="si_text1"
          slot="si_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.si_text2 || '自定义字段2'"
          v-model="form.main.si_text2" :caller="caller" fieldName="si_text2"
          slot="si_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.si_text3 || '自定义字段3'"
          v-model="form.main.si_text3" :caller="caller" fieldName="si_text3"
          slot="si_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.si_text4 || '自定义字段4'"
          v-model="form.main.si_text4" :caller="caller" fieldName="si_text4"
          slot="si_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.si_text5 || '自定义字段5'"
          v-model="form.main.si_text5" :caller="caller" fieldName="si_text5"
          slot="si_text5" hidden="true"
        />
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    ComboField,
    CurrencyField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/sale/serveitem",
      codeField: "si_code",
      caller: "ServeItem",
      xtype: "make-serveitem-formpanel",
      form: {
        main: {

        },
        items: [
          {

          }
        ],
      },
    };
  },
  methods: {
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main
      if (!main.si_name) {
        me.$weui.topTips("请输入名称", 2000);
      } else if (!main.si_spec) {
        me.$weui.topTips("请输入规格", 2000);
      } else if (!main.si_currency) {
        me.$weui.topTips("请选择币别", 2000);
      } else if (!main.si_price) {
        me.$weui.topTips("请输入含税单价", 2000);
      } else {
        me.p_save();
      }
    },
    p_save() {
      const me = this

      me.$loading({
        url: "/api/sale/serveitem/save?caller=ServeItem",
        method: "POST",
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.$router.back()
        }
      })
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({

      });
    }
  },
};
</script>